import { LoadGLTFModel } from '@xeokit/xeokit-sdk';

export async function loadModelGLTF(
  id: string,
  source: string,
  name: string,
  options?: {
    edges?: boolean;
    pbr?: boolean;
    position?: (number | null | undefined)[];
    rotation?: (number | null | undefined)[];
    scale?: (number | null | undefined)[];
  },
): Promise<string | undefined> {
  const viewerStore = useViewerStore();
  const loader = viewerStore.getLoaders().gltfLoaderPlugin;

  if (!viewerStore.isInitialized || !loader) return;

  const t0 = performance.now();

  const loaderOptions: LoadGLTFModel = {
    id,
    src: source,
    autoMetaModel: true,
    edges: options?.edges ?? false,
    rotation: [90, 0, 0],
  };

  const sceneModel = loader.load(loaderOptions);

  return new Promise((resolve, reject) => {
    sceneModel.on('loaded', function () {
      console.log(`Model loaded in ${Math.floor(performance.now() - t0) / 1000.0} seconds`);

      if (options) {
        updateModel(sceneModel, {
          position: options.position,
          //rotation: options.rotation,
          // rotation: options.rotation
          //   ? [(options.rotation[0] ?? 0) + 90, options.rotation[1], options.rotation[2]]
          //   : [90, 0, 0],
          //scale: options.scale,
        });
      }
      viewerStore.saveModelMemento(sceneModel.id);
      resolve(String(sceneModel.id));
    });

    sceneModel.on('error', function (error) {
      console.error(error);
      reject(error);
    });
  });
}
